declare var $:any;
import { Component, OnInit,ViewChild } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.css']
})
export class PdfviewerComponent implements OnInit {
  public PdfURL:String="";
  @ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;
  constructor(private titleService: Title) { 
    this.titleService.setTitle("Report");}

  ngOnInit(): void {
    var self=this;
    let height=$(window).innerHeight();
    $('#rowdiv').css("height",height+"px");
    $('#pdfjs').css("height",height+"px");
    
    $(window).resize(function(){
        $('#rowdiv').css("height",height+"px");
        $('#pdfjs').css("height",height+"px");
    });
    
    if(sessionStorage.getItem("pdfURL")!="" && sessionStorage.getItem("pdfURL")!=null && sessionStorage.getItem("pdfURL")!=undefined){
      this.titleService.setTitle("Report::" +sessionStorage.getItem("PatientName") + "::" +sessionStorage.getItem("SIDDate") + "::" + sessionStorage.getItem("TestName"));

      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        setTimeout(() => {        
        $('#rowdiv').css('display','none');
        $('#pdfjs').css('display','block');
        self.pdfViewerAutoLoad.pdfSrc = sessionStorage.getItem("pdfURL"); // pdfSrc can be Blob or Uint8Array
        self.pdfViewerAutoLoad.refresh();
      }, 500);
      }
      else{
        $('#rowdiv').css('display','block');
        $('#pdfjs').css('display','none');
        $('#embed').attr('src',sessionStorage.getItem("pdfURL"));
      }
    }
    
    setTimeout(() => {
        $(".content-wrapper").css("padding","unset");
    }, 1000);
    }

}
